import React, { useState } from 'react'
import { Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import googleWalletImg from "../../../assests/images/GoogleWallet.svg"
import { googleWalletAutobiography } from '../../../api/UserRequest';


function AddToGoogleWallet({ cardID, ITxtColor, IColor }) {
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage()
    const error = () => {
        messageApi.open({
            type: 'error',
            content: 'Some thing went wrong, please try after some time.',
        });
    };
    const handleGoogleAddToWallet = async () => {
        try {
            setLoading(true);

            const { data } = await googleWalletAutobiography(cardID);
            if (data.success) {

                window.location.href = data.walletUrl;
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            error()
            console.log(err);
        }
    };

    return (
        <div>
            <Spin spinning={loading} indicator={<LoadingOutlined spin />} size="small" >

                <img className='w-[160px] h-[48px] cursor-pointer' onClick={handleGoogleAddToWallet} src={googleWalletImg} alt="" srcset="" />
            </Spin>
            {contextHolder}
        </div>
    )
}

export default AddToGoogleWallet